import { SearchFilterKeys, mileageData } from '@cinch-nx/data-search'
import { options } from '../formatter-options'
import { getFormattedBodyType } from './body-type-formatter'
import { getFormattedColour } from './colour-formatter'
import { getFormattedDoors } from './doors-formatter'
import { getFormattedDriveType } from './drive-type-formatter'
import { getFormattedEngineSizeCcRange } from './engine-size-formatter'
import { getFormattedFeatures } from './features-formatter'
import { getFormattedFinanceType } from './finance-type-formatter'
import { getFormattedFuelType } from './fuel-type-formatter'
import { getFormattedGearbox } from './gearbox-formatter'
import {
  getFormattedMake,
  getFormattedModel,
  getFormattedVariant,
} from './make-model-variant-formatter'
import { getFormattedMileage } from './mileage-formatter'
import { getFormattedPriceRange } from './price-formatter'
import { getFormattedSeats } from './seats-formatter'
import { getFormattedStoreLocations } from './store-location-formatter'
import { getFormattedTags } from './tags-formatter'
import { getFormattedYearRange } from './year-formatter'
import { getFormattedRangeInMiles } from './range-in-miles-formatter'

export const formatFilterPill = (
  key: SearchFilterKeys,
  value: string,
  financeType?: string[],
) => {
  switch (key) {
    case 'make': {
      return getFormattedMake(value, options.mappings)
    }
    case 'model': {
      return getFormattedModel(value, options.mappings)
    }
    case 'trim': {
      return getFormattedVariant(value, options.mappings)
    }
    case 'fromPrice': {
      return getFormattedPriceRange(
        Number.parseInt(value, 10),
        undefined,
        options.useMonthly,
        financeType,
      )
    }
    case 'toPrice': {
      return getFormattedPriceRange(
        undefined,
        Number.parseInt(value, 10),
        options.useMonthly,
        financeType,
      )
    }
    case 'fromYear': {
      return getFormattedYearRange(
        Number.parseInt(value, 10),
        undefined,
        options.ageData ?? [],
      )
    }
    case 'toYear': {
      return getFormattedYearRange(
        undefined,
        Number.parseInt(value, 10),
        options.ageData ?? [],
      )
    }
    case 'mileage': {
      return getFormattedMileage(Number.parseInt(value, 10), mileageData ?? [])
    }
    case 'rangeInMiles': {
      return getFormattedRangeInMiles(value)
    }
    case 'fuelType': {
      return getFormattedFuelType([value])
    }
    case 'colour': {
      return getFormattedColour([value])
    }
    case 'bodyType': {
      return getFormattedBodyType([value])
    }
    case 'gearbox': {
      return getFormattedGearbox([value])
    }
    case 'fromEngineSize': {
      return getFormattedEngineSizeCcRange(Number.parseInt(value, 10))
    }
    case 'toEngineSize': {
      return getFormattedEngineSizeCcRange(
        undefined,
        Number.parseInt(value, 10),
      )
    }
    case 'doors': {
      return getFormattedDoors([value])
    }
    case 'seats': {
      return getFormattedSeats([value])
    }
    case 'driveType': {
      return getFormattedDriveType([value])
    }
    case 'tags': {
      return getFormattedTags(value)
    }
    case 'features': {
      return getFormattedFeatures([value])
    }
    case 'store': {
      return getFormattedStoreLocations([value])
    }
    case 'financeType': {
      return getFormattedFinanceType(value)
    }
    default: {
      return value
    }
  }
}
